(function (ws) {
    'use strict';
    ws.views.myprofilePageForms = ws.views.form.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'user',
        GTM_EVENT_ACTION: 'change_contact_info',

        mainError: '.error-message',

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.form.prototype.initialize.call(this);
            this.$emailField = this.$('input.email');
            this.$mobileField = this.$('input.cmp-mobileNumber');
        },

        events: {
            'blur #j_firstname': 'checkAttackValue',
            'blur #j_lastname': 'checkAttackValue',
            'keyup #j_firstname': 'checkAttackValue',
            'keyup #j_lastname': 'checkAttackValue'
        },

        /**
         * Additional field validations
         */
        additionalValidation: function () {
            this.checkEmail();
            this.checkPhone();
        },

        // Special character check
        checkAttackValue: function(e) {
            globals.attackValueCheck(e);
        },

        /**
         * overrides submit to log GTM event
         */
        submitForm: function() {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
            ws.views.form.prototype.submitForm.call(this);
        }

    });
})(westcon);
